import { useCookie } from '#app'

export function useGuestCookie() {
  const guestUserActiveCookie = useCookie<boolean>('guest-user-active', {
    default: () => false,
    watch: true,
    maxAge: 30 * 24 * 60 * 60,
    httpOnly: false,
    secure: process.env.NUXT_PUBLIC_APP_ENV === 'production',
    sameSite: 'strict',
    path: '/',
  })

  const setGuestUserActive = (value: boolean) => {
    guestUserActiveCookie.value = value
  }

  return {
    guestUserActiveCookie,
    setGuestUserActive,
  }
}
